module.exports = __webpack_public_path__ + "static/media/lp_service.8d34877e.png";